import { make } from 'vuex-pathify'
import store from '../index'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'
import axios from 'axios'

const state = {
  email: {},

  senders: [],
  recipients: [],

  loading: false,
  dialog: false,
}

const mutations = make.mutations(state)

const actions = {
  add: ({ state }, data = {}) => {
    const company = store.get('authStore/currentCompany')
    const isOAuth = company?.authType === 'oauth2' || (!!company?.emailProvider && company.emailProvider !== 'custom')
    state.email = {
      from: isOAuth ? (company.mailboxEmail || company.emailSmtp || company.email) : (company.emailSmtp || company.email),
      to: data.email ? [data.email] : [],
      subject: data.subject,
    }
    state.dialog = true

    store.dispatch('emailStore/loadCombos')
  },

  loadCombos: async () => {
    store.dispatch('emailStore/getSenders')
    store.dispatch('emailStore/getRecipients')
  },

  send: ({ state }, email) => {
    state.loading = true
    return axios.post(`${process.env.VUE_APP_API_URL}/email?${getQueryFromFilter({
      // parâmetro obrigatório
      userId: store.get('authStore@currentUser').id,
      companyId: store.get('authStore@currentCompany').id,
    })}`, email)
      .then(res => {
        state.dialog = false
        showSuccess('Email enviado com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  getSenders: ({ state }) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/get-senders?${getQueryFromFilter({
      // parâmetro obrigatório
      userId: store.get('authStore@currentUser').id,
      companyId: store.get('authStore@currentCompany').id,
    })}`)
      .then(res => {
        state.senders = res.data

        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  getRecipients: ({ state }) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/get-recipients?${getQueryFromFilter({
      // parâmetro obrigatório
      userId: store.get('authStore@currentUser').id,
      companyId: store.get('authStore@currentCompany').id,
    })}`)
      .then(res => {
        state.recipients = res.data

        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  test: ({ state }, config) => {
    state.loading = true
    return axios.put(`${process.env.VUE_APP_API_URL}/email`, config)
      .then(res => {
        showSuccess('Email enviado com sucesso! Verifique sua caixa de email')
      })
      .catch(showError)
      .finally(() => {
        state.loading = false
      })
  },

  connectOAuth: ({ state }, { provider, config }) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/email/oauth/${provider}/connect?${getQueryFromFilter({
      companyId: config.id || store.get('authStore@currentCompany').id,
    })}`)
      .then(res => res.data)
      .catch(showError)
      .finally(() => {
        state.loading = false
      })
  },

  completeOAuth: ({ state }, { provider, code, state: oauthState }) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/email/oauth/${provider}/complete?${getQueryFromFilter({
      code,
      state: oauthState,
    })}`)
      .then(res => res.data)
      .catch(error => {
        showError(error)
        throw error
      })
      .finally(() => {
        state.loading = false
      })
  },

  disconnectOAuth: ({ state }, { provider, companyId }) => {
    state.loading = true
    return axios.post(`${process.env.VUE_APP_API_URL}/email/oauth/${provider}/disconnect`, {
      companyId: companyId || store.get('authStore@currentCompany').id,
    })
      .then(_ => {
        showSuccess('Conta desconectada com sucesso')
      })
      .catch(showError)
      .finally(() => {
        state.loading = false
      })
  },

  connectMicrosoft: ({ dispatch }, config) => dispatch('connectOAuth', { provider: 'microsoft', config }),

  completeMicrosoft: ({ dispatch }, { code, state }) => dispatch('completeOAuth', { provider: 'microsoft', code, state }),

  disconnectMicrosoft: ({ dispatch }, companyId) => dispatch('disconnectOAuth', { provider: 'microsoft', companyId }),
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
